import { axiosGet } from '@/api/AxiosApi';

export const telegramForm = (text: string) => {
  const payload = {
    project: process.env.NODE_ENV === 'production' ? 'shuffle.hupayx.io' : 'shuffledev1116.hupayx.io',
    value: {
      error: text,
    },
  };
  telegramBot(JSON.stringify(payload));
};

const telegramBot = (text: any) => {
  const payload = {
    apiUrl: 'https://api.telegram.org',
    path: `/bot${process.env.REACT_APP_TELEGRAM_BOT}/sendmessage?chat_id=${process.env.REACT_APP_TELEGRAM_BOT_ID}&text=${text}`,
  };

  axiosGet(payload);
};
